import { ServerClient } from "@hermes/shared/src/server-client/ServerClient";
import { getFirebaseWebsite } from "../firebase";

const server = new ServerClient(getFirebaseWebsite());

export const getServer = () => server;